<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" xs="12" md="8" lg="6">
        <v-expansion-panels v-if="$store.state.user.uid">
          <v-expansion-panel>
            <v-expansion-panel-header class="headline">Create a match</v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-form @submit.prevent="submit">
                  <v-autocomplete label="Champion" v-model="form.data.champion" :items="form.champions" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-sword' : undefined"/>

                  <v-text-field label="Wager" type="number" v-model="form.data.wager" :error-messages="wagerErrors" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-currency-usd' : undefined"/>

                  <v-checkbox label="Is this a private match?" v-model="form.data.private"/>

                  <div class="py-2 d-flex">
                    <v-spacer/>

                    <v-btn color="primary" type="submit">Create</v-btn>
                  </div>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        
        <v-alert type="info" v-else>
          Sign in to create a match
        </v-alert>

        <v-card class="mt-4 elevation-2">
          <v-card-title class="headline">Matches</v-card-title>
          
          <v-card-text>
            <v-data-table :loading="loading" :footer-props="{'disable-items-per-page': true}" :headers="headers" :items="matches" :items-per-page="5">
              <template v-slot:item.rank="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-img width="32" height="32" :src="`/images/${item.tier.toLowerCase()}.png`" v-on="on"/>
                  </template>

                  <span>{{ item.rank }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.view="{ item }">
                <v-btn color="primary" tile :to="`/match/${item.uid}`">
                  View
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minValue } from 'vuelidate/lib/validators';

import config from '@/lib/config';

const headers = [{ align: 'left', text: 'Host', value: 'host'}, { align: 'left', text: 'Champion', value: 'champion'}, { align: 'left', text: 'Rank', value: 'rank' }, { align: 'left', text: 'Wager', value: 'wager' }, { align: 'right', sortable: false, text: '', value: 'view' }];

export default {
  name: 'Matches',
  mixins: [validationMixin],
  validations: {
    wager: { minValue: minValue(0) }
  },
  data() {
    return {
      form: {
        champions: ['All', ...config.championsFormatted],
        data: {
          champion: 'All',
          wager: 0,
          private: false
        }
      },
      headers: headers,
      matches: [],
      loading: true
    };
  },
  created() {
    this.fetchMatches();
  },
  computed: {
    wagerErrors() {
      const errors = [];

      if(!this.$v.wager.$dirty) {
        return errors;
      }

      !this.$v.wager.minValue && errors.push('Wager must be positive');

      return errors;
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      
      if(!this.$v.$invalid) {
        this.createMatch();
      }
    },
    createMatch() {
      this.$store.dispatch('createMatch', {
        champion: this.form.data.champion,
        wager: this.form.data.wager,
        private: this.form.data.private
      })
      .then((id) => {
        this.$router.push(`/match/${id}`);
      })
      .catch(() => {

      });
    },
    async fetchMatches() {
      await this.$store.dispatch('fetchMatches');

      const matches = this.$store.state.matches;
      const data = [];

      for(let match of matches) {
        data.push({
          host: match.host.summoner.name,
          champion: match.champion,
          tier: match.host.summoner.tier,
          wager: match.wager,
          uid: match.uid
        });
      }

      this.matches = data;
      this.loading = false;
    }
  }
};
</script>